import BasePage from '@components/Layouts/BasePage'
import { OrgRoutesNavGroup } from '@components/Navigation/OrgRoutesNavGroup'
import { ManageSelectedOrgProvider } from '@features/organisations/contexts/ManageSelectedOrg'
import { PermissionsCheckerProvider } from '@lib/permissions'
import { RouteLoaderData } from '@customTypes/index'
import {
  createFileRoute,
  Outlet,
  useParams,
  useRouterState,
  useLocation,
} from '@tanstack/react-router'

const OrgIdRoute = () => {
  const matches = useRouterState({ select: (s) => s.matches })
  const { orgId } = useParams({ from: '/_auth/o/$orgId' })

  const location = useLocation()
  const matchWithTitle = [...matches].reverse().find((d) => d.context.getTitle)
  const title = matchWithTitle?.context.getTitle() || 'Cloudmix'

  const breadcrumbs = matches
    .filter((match) => (match.loaderData as RouteLoaderData)?.crumb)
    .map(({ pathname, loaderData }) => ({
      title: (loaderData as RouteLoaderData)?.crumb,
      path: pathname,
      isCurrentPage: pathname === location.pathname,
    }))

  const constrainHeight = matches.some(
    (match) => (match.loaderData as RouteLoaderData)?.constrainHeight
  )

  return (
    <ManageSelectedOrgProvider>
      <PermissionsCheckerProvider>
        <BasePage
          title={title}
          navigation={<OrgRoutesNavGroup orgId={orgId} />}
          breadcrumbs={breadcrumbs}
          constrainHeight={constrainHeight}
        >
          <Outlet />
        </BasePage>
      </PermissionsCheckerProvider>
    </ManageSelectedOrgProvider>
  )
}

export const Route = createFileRoute('/_auth/o/$orgId')({
  component: OrgIdRoute,
  loader: ({ context, params }) => {
    context.setOrg(params.orgId)
  },
})
